import { goUrl, onOutboundClick } from '@/lib/outbound';

// <AffiliateLink href="https://www.omio.com/..." placement="route-cta" partner="omio">Check times</AffiliateLink>
// Tracked, sponsored, opens in a new tab. Use for every partner link so clicks are logged per site.
export default function AffiliateLink({ href, placement = '', partner = '', site, className = '', children, ...rest }) {
  return (
    <a
      href={goUrl(href, { site, placement })}
      target="_blank"
      rel="sponsored nofollow noopener"
      className={className}
      onClick={() => onOutboundClick(href, { site, placement, partner })}
      {...rest}
    >
      {children}
    </a>
  );
}

// Short disclosure required next to affiliate links (FTC / ASA / CMA).
export function AffiliateDisclosure({ className = '', children }) {
  return (
    <p className={`text-xs text-gray-500 ${className}`}>
      {children || 'We may earn a commission when you book or buy through links on this page, at no extra cost to you. It never changes what we recommend.'}
    </p>
  );
}
